// View toggle button group — switches between Feed and Editorial layout.
// Matches the .viewtoggle element in design/project/scripts/app.jsx.
import type { FeedView } from "../hooks/useFeed";

interface Props {
  view: FeedView;
  onChange: (v: FeedView) => void;
}

export function ViewToggle({ view, onChange }: Props) {
  return (
    <div className="hub-viewtoggle" role="group" aria-label="View layout">
      <button
        className={`hub-viewtoggle__btn${view === "feed" ? " hub-viewtoggle__btn--active" : ""}`}
        aria-pressed={view === "feed"}
        onClick={() => onChange("feed")}
        type="button"
      >
        {/* List icon */}
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
        {" Feed"}
      </button>
      <button
        className={`hub-viewtoggle__btn${view === "editorial" ? " hub-viewtoggle__btn--active" : ""}`}
        aria-pressed={view === "editorial"}
        onClick={() => onChange("editorial")}
        type="button"
      >
        {/* Layout grid icon */}
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
        </svg>
        {" Editorial"}
      </button>
    </div>
  );
}
